'use strict';

var angular = require('angular');
var FaresClassUsageGridModalDirective = function FaresClassUsageGridModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fares-class-usage-grid-modal.html'),
    controller: 'FaresClassUsageGridController',
    scope: true,
    link: function link(scope, element) {
      scope.gridSmallModalJustClosed = false;
      element.on('shown.bs.modal', function (e) {
        if (element.attr('id') === angular.element(e.target).attr('id')) {
          scope.classUsageGridVisible = true;
          scope.$apply();
        }
      });
      element.on('hidden.bs.modal', function (e) {
        if (element.attr('id') === angular.element(e.target).attr('id')) {
          scope.classUsageGridVisible = false;
          scope.$apply();
        }
      });
      element.on('hide.bs.modal', function (e) {
        var closingModal = angular.element(e.target);

        //when we close small filtering modal windows, we need to prevent main modal with grid from being closed
        if (element.attr('id') !== closingModal.attr('id')) {
          scope.gridSmallModalJustClosed = true;
        } else if (element.attr('id') === closingModal.attr('id') && scope.gridSmallModalJustClosed) {
          e.stopPropagation();
          e.preventDefault();
          scope.gridSmallModalJustClosed = false;
        }
      });
    }
  };
};
FaresClassUsageGridModalDirective.$inject = ['$rootScope'];
module.exports = FaresClassUsageGridModalDirective;